// Frontend/src/app/public/authentication/authentication.component.ts
import { Component, HostBinding } from '@angular/core';
import { Router } from '@angular/router';
import {LoginLayoutComponent} from '../../core/components/login-layout/login-layout.component';
import {AuthService} from '../../core/services/auth.service';

@Component({
  selector: 'app-authentication',
  standalone: true,
  imports: [LoginLayoutComponent],
  templateUrl: './authentication.component.html',
  styleUrl: './authentication.component.css',
})
export class AuthenticationComponent {
  usuarioTipo: string = 'Usuario';
  errorMessage: string | null = null;

  constructor(private authService: AuthService, private router: Router) {}

  handleLogin({ userName, password }: { userName: string; password: string }): void {
    // Intentar autenticación como Administrador
    this.authService.loginAdmin(userName, password, 'Administrador').subscribe(
      () => {
        this.router.navigate(['/admin']); // Redirigir al dashboard de Administrador
      },
      (errorAdmin) => {
        // Si falla, intentar como Cajero
        this.authService.loginCashier(userName, password, 'Cajero').subscribe(
          () => {
            this.router.navigate(['/cajero']); // Redirigir al dashboard de Cajero
          },
          (errorCashier) => {
            // Mostrar error si ambas autenticaciones fallan
            this.errorMessage =
              errorCashier.status === 401 || errorCashier.status === 403
                ? 'Usuario o contraseña incorrectos.'
                : 'Hubo un problema al iniciar sesión. Inténtalo de nuevo.';
          }
        );
      }
    );
  }
}
